<script lang="ts" setup>
import type { GeneralNavigationFragment } from '~~layers/.nuxt/graphql-operations'

defineProps<{
  item: GeneralNavigationFragment
  index: number
}>()

const {
  showSubmenu,
  toggleSubnavigation,
} = useNavigation()
</script>

<template>
  <div
    class="subnavigation"
    :class="{ 'subnavigation--open': index === showSubmenu }"
  >
    <div class="subnavigation__container">
      <div class="subnavigation__header">
        <button
          type="button"
          class="subnavigation__back"
          @click="toggleSubnavigation(index)"
        >
          <NuxtIcon name="icon:arrow" />
          <!-- <span>{{ $t('Back') }}</span> -->
          <span class="subnavigation__name">{{ item?.Title }}</span>
        </button>
      </div>

      <AppLink
        v-if="item.Link && item.AllTitle"
        :to="item.Link"
        class="subnavigation__title"
      >
        <span>{{ item.AllTitle }}</span>
      </AppLink>

      <LazyNavigationRecursive
        v-if="item?.Subnavigation?.filter(subnav => subnav?.Show)?.length"
        :items="item?.Subnavigation"
        :level="2"
        :banners="item?.Banners"
        class="subnavigation__recursive"
      />

      <div
        v-for="subnav in item.Richtexts"
        :key="subnav"
        class="subnavigation__richtext"
      >
        <StrapiBlocksText
          v-if="subnav?.Richtext"
          :nodes="subnav.Richtext"
        />
      </div>

      <div
        v-for="banner in item?.Banners"
        :key="banner"
        class="subnavigation__banner"
      >
        <StrapiBanner
          :banner="banner"
          lazy
        />
      </div>
    </div>
  </div>
</template>

<style>
@import url("~layers/components/Navigation/Panel.css");
</style>
